import React from "react";
import { Col, Row, Typography, Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import { translate } from "../../../locale";
import PillsTable from "../../../components/Tables/PillsTable";

const { Title } = Typography;

const Pills = () => {
  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{translate("Píldoras")}</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Píldoras")}
          </Title>
        </Col>

        <Col span="24" className="mt-6">
          <PillsTable />
        </Col>
      </Row>
    </div>
  );
};

export default Pills;
